{
  "version": 1,
  "asset_id": "4c3f2193-6b94-4c16-9927-8054979ded4c",
  "project_id": "63ffb125-aed4-4f54-959a-0b116fa77b1d",
  "url": "/__l5e/assets-v1/4c3f2193-6b94-4c16-9927-8054979ded4c/hiatal-type-1-1536.jpg",
  "r2_key": "a/v1/63ffb125-aed4-4f54-959a-0b116fa77b1d/4c3f2193-6b94-4c16-9927-8054979ded4c/hiatal-type-1-1536.jpg",
  "original_filename": "hiatal-type-1-1536.jpg",
  "size": 230457,
  "content_type": "image/jpeg",
  "created_at": "2026-09-24T19:21:18Z"
}
